import { API } from '../api';

const getById = (id) => {
    return API.get('client/schedule/schedule/get-schedule', { id: id })
        .then((response) => {
            if (API.isSuccess(response)) {
                return response.data;
            }

            throw new Error('error');
        });
};

const getByAgenda = (id = null, groupId = null) => {
    return API.get('client/schedule/schedule/get-by-agenda', { agenda: id, group: groupId })
        .then((response) => {
            if (API.isSuccess(response)) {
                return response.data;
            }

            return [];
        });
};

const loadSchemaData = () => {
    return API.get('client/schedule/schedule/load-schema-data')
        .then((response) => {
            if (API.isSuccess(response)) {
                return response.data;
            }

            return [];
        });
};

const getFreeSlotCount = (start, end, id, type) => {
    return API.get('client/schedule/schedule/get-free-slot-count', { start: start, end: end, id: id, type: type })
        .then((response) => {
            if (API.isSuccess(response)) {
                return response.data;
            }
        })
        .catch((error) => { });
};

const saveBlocks = (blocks, agendaId = null) => {
    return API.post('client/schedule/block/set-blocks', { data: { blocks: blocks, agenda: agendaId } })
        .then(
            response => {
                if (response.status === 'success') {
                    return true;
                }

                throw new Error(response.data);
            }
        );
};

const composeSlots = (scheduleId, data) => {
    return API.post('client/schedule/slot/compose-slots', { schedule: scheduleId, data: data })
        .then((response) => {
            if (API.isSuccess(response)) {
                return true;
            }

            return false;
        });
};

const updateSlotCategory = (slotId, categoryId, start, end) => {
    return API.post('client/schedule/slot/update-category', {
        data: {
            category: categoryId,
            slotId: slotId,
            start: start,
            end: end
        }
    })
        .then((response) => {
            return response;
        });
}

const getPeriodsBySchedule = (scheduleId) => {
    return API.get('client/schedule/period/get-by-schedule', { id: scheduleId })
        .then((response) => {
            if (API.isSuccess(response)) {
                return response.data.periods;
            }

            return [];
        });
};

const updatePriorityBreakHours = (scheduleId, data) => {
    return API.post('client/schedule/slot/update-priority-breakhours', { schedule: scheduleId, data: { slots: data } })
        .then((response) => {
            if (API.isSuccess(response)) {
                return true;
            }

            throw new Error('error');
        });
};

const findFirstAvailableSlotForAppointment = (appointmentId) => {
    return API.get('client/schedule/schedule/find-first-available-slot', { id: appointmentId })
        .then((response) => {
            if (API.isSuccess(response)) {
                return response.data;
            }

            return [];
        });
}

export const ApiScheduleService = {
    getById,
    getByAgenda,
    loadSchemaData,
    getFreeSlotCount,
    saveBlocks,
    composeSlots,
    getPeriodsBySchedule,
    updatePriorityBreakHours,
    updateSlotCategory,
    findFirstAvailableSlotForAppointment
};